import React from 'react'

export default function JobPostingDescription({ description }) {
  let formattedDescription = description
  if (typeof description === 'string') {
    formattedDescription = description.split('\n').map((line, i) => {
      return (
        <p className="text-break" key={i}>
          {line}
        </p>
      )
    })
  } else formattedDescription = <p className="text-break">{description}</p>

  return (
    <div className="overflow-auto" style={{ flex: 1 }}>
      {formattedDescription}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/JobSearch/components/JobPostingDescription.js